module.exports = __webpack_public_path__ + "img/returning-customers.854d6a2d.webp";